import { render, staticRenderFns } from "./UcRentalMiniCard.yaml?vue&type=template&id=38b256e0&component"
import script from "./UcRentalMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcRentalMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports